import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { inject, Injectable } from '@angular/core';
import { BackgroundTaskLaunchService } from '../../../../modules/layout/store/background-tasks/background-task-launch.service';
import {
    BackgroundActionType,
    VoucherExportKind,
} from '@libs/types/src/notifications/types/background-action.types';
import type { VouchersExportInput } from '@libs/types/src/services/input-type/voucher/voucher.export-input';

@Injectable()
export class PrintVoucherDialogStore extends ComponentStoreV2Factory {
    private readonly backgroundTaskLauncher = inject(
        BackgroundTaskLaunchService,
    );

    public start(input: VouchersExportInput): Promise<boolean> {
        return this.backgroundTaskLauncher.start({
            type: BackgroundActionType.VOUCHER_EXPORT,
            payload: {
                kind: VoucherExportKind.VOUCHER,
                input,
            },
            alreadyRunningMessage:
                'voucher.export.backgroundTask.messages.alreadyRunning',
            failedMessage: 'voucher.export.backgroundTask.messages.startFailed',
        });
    }
}
